// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { Product } from './product';
import { ProductTypeConfig } from './product-type-config';
import { SupplierInventoryApproval } from './supplier-inventory-approval';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import { PricedProductTypeFeatureChoice } from './priced-product-type-feature-choice';
import * as _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeConfigProduct extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // Also See ProductTypeConfig.lookupPrices()
  _pricedProductTypeFeatureChoices!: PricedProductTypeFeatureChoice[];

  lookupPrices() {
    const fcs = this.product.productFeatureChoices.map((x) => x.featureChoice);
    this._pricedProductTypeFeatureChoices = this.productTypeConfig.pricedProductType.pricedProductTypeFeatureChoices.filter((pptfc) =>
      fcs.includes(pptfc.featureChoice),
    );
  }

  // Next 4 methods all require that queries to populate all navigations have been made.
  getBasePrice() {
    const useInventory = this.productTypeConfig.isInventory;
    return useInventory ? this.productTypeConfig.pricedProductType.inventoryPrice : this.productTypeConfig.pricedProductType.basePrice;
  }

  getKitOverridePrice() {
    return this.productTypeConfig.pricedProductType.accountOwnedBasePrice;
  }

  getActualUnitPrice() {
    if (!this.productTypeConfig) return 0;
    return this.productTypeConfig.pricedProductType.accountOwnedBasePrice ?? this.productTypeConfig.pricedProductType.basePrice;
  }

  // requires that lookpPrices() has been called previously.
  getExtraPrice() {
    if (!this.productTypeConfig) return 0;
    const useInventory = this.productTypeConfig.isInventory;
    const extraPrice = _.sum(this._pricedProductTypeFeatureChoices?.map((pptfc) => useInventory ? pptfc.inventoryPrice : pptfc.price));
    return extraPrice;
  }

  getAddonsPrice() {
    if (!this.productTypeConfig) return 0;
    const ptcAddons = this.productTypeConfig.productTypeConfigAddons;
    if (ptcAddons.length == 0) return 0;
    const useInventory = this.productTypeConfig.isInventory;
    const addonsPrice = _.sum(ptcAddons.map((ptca) => useInventory ? ptca.pricedAddon.inventoryPrice : ptca.pricedAddon.price));
    return addonsPrice;
  }

  getTotalPrice() {
    return this.getBasePrice() + this.getExtraPrice() + this.getAddonsPrice();
  }

  getStatusParents() {
    return [this.productTypeConfig];
  }

  getStatusId() {
    return this.activeStatusId;
  }

  get hasStatusViolation(): boolean {
    const result =
      this.activeStatusId > ActiveStatusEnum.Active ||
      this.product.activeStatusId > ActiveStatusEnum.Active ||
      this.product.productType?.activeStatusId > ActiveStatusEnum.Active ||
      this.product.getWorkingFeatureChoiceStatus()!.activeStatusId > ActiveStatusEnum.Active;
    return result;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Guid FK product */
  productId!: string;
  /** Guid FK productTypeConfig */
  productTypeConfigId!: string;
  /** Binary */
  rowVersion!: any;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK productId */
  product!: Product;
  /** FK productTypeConfigId */
  productTypeConfig!: ProductTypeConfig;
  /** Inv FK productTypeConfigProductId */
  supplierInventoryApprovals!: SupplierInventoryApproval[];
}

